import {
  getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags,
  getGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  data: GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200;
};

type IUseGetPartnerAdminsPartnerFeatureFlags = (args: Args) => ReturnType;

/**
 * パートナーの機能フラグを取得するカスタムフック
 *
 * @param args.threeLetterCode - パートナーを識別する3文字コード
 * @returns data - パートナー機能フラグ一覧
 */
export const useGetPartnerAdminsPartnerFeatureFlags: IUseGetPartnerAdminsPartnerFeatureFlags = ({
  threeLetterCode,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlagsKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
